import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatCard = ({
  title,
  value,
  displayValue,
  hint,
  change,
  changeType,
  changeLabel,
  icon: Icon,
  color = 'primary',
}) => {
  const showChange = change != null && change !== '';
  const colorClasses = {
    primary: {
      bg: 'bg-primary-50',
      text: 'text-primary-600',
      icon: 'text-primary-600'
    },
    success: {
      bg: 'bg-success-50',
      text: 'text-success-600',
      icon: 'text-success-600'
    },
    warning: {
      bg: 'bg-warning-50',
      text: 'text-warning-600',
      icon: 'text-warning-600'
    },
    danger: {
      bg: 'bg-danger-50',
      text: 'text-danger-600',
      icon: 'text-danger-600'
    }
  };
  
  const colors = colorClasses[color];
  
  return (
    <div className="card">
      <div className="card-content">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
            <p className="text-2xl font-bold text-gray-900">
              {displayValue != null ? displayValue : Number(value ?? 0).toLocaleString('pt-BR')}
            </p>
            {hint ? <p className="mt-1 text-xs text-gray-500">{hint}</p> : null}
            {showChange && (
              <div className="flex items-center mt-2">
                {changeType === 'positive' ? (
                  <TrendingUp className="w-4 h-4 text-success-500 mr-1" />
                ) : (
                  <TrendingDown className="w-4 h-4 text-danger-500 mr-1" />
                )}
                <span
                  className={`text-sm font-medium ${
                    changeType === 'positive' ? 'text-success-600' : 'text-danger-600'
                  }`}
                >
                  {change} {changeLabel || 'este mês'}
                </span>
              </div>
            )}
          </div>
          <div className={`w-12 h-12 rounded-lg ${colors.bg} flex items-center justify-center`}>
            <Icon className={`w-6 h-6 ${colors.icon}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
